import { Component, Input, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { AutosBusquedaStoreService } from '../../services/store/autos-busqueda-store.service';
import { Auto, Version } from '../../../comun/model/autos.model';
import { UsoVehiculoComponent } from '../uso-vehiculo/uso-vehiculo.component';
import { TranslateModule } from '@ngx-translate/core';
import { CaCardComponent } from '@global-front-components/ui/card';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CatalogoProtocolo} from '../../../comun/model/catalogo.model';
import { CatalogoSvgStoreService } from '../../../comun/services/store/catalogo-svg-store.service';
import { AuthStoreService } from '../../../comun/services/store/auth-store.service';
import { DatosPersonalesComponent } from '../../../comun/components/datos-personales/datos-personales.component';
import { DatosPersonalesConfig, DatosDomicilioConfig, ModoEdicion } from '../../../ui/model/catalogo-config.model';
import { CaRadioButtonComponent, CaRadioGroupDirective } from '@global-front-components/ui/radio-button';
import { DatosDomicilioComponent } from '../../../comun/components/datos-domicilio/datos-domicilio.component';
import { DatosConductorComponent } from '../datos-conductor/datos-conductor.component';
import { CaIcon } from '@global-front-components/ui/form-field';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { CoberturasComponent } from '../../../comun/components/coberturas/coberturas.component';
import { Capital, Cobertura, Domicilio, Persona, Poliza, Pregunta, Recibo, Riesgo } from '../../../comun/model/poliza.model';
import { DatosAdicionalesComponent } from '../../../comun/components/datos-adicionales/datos-adicionales.component';
import { DatosEconomicosComponent } from "../../../comun/components/datos-economicos/datos-economicos.component";
import { PolizaUtils } from '../../../comun/util/poliza.utils';
import { PolizaStoreService } from '../../../comun/services/store/poliza-store.service';
import { Router } from '@angular/router';
import { PolizaApiService } from '../../../comun/services/api/poliza-api.service';
import { FlujoPolizaNavigationComponent } from '../../../comun/components/base/flujo-poliza-navigation.component';
import { AutosApiService } from '../../services/api/autos-api.service';
import { TarificacionComponent } from '../../../comun/components/tarificacion/tarificacion.component';
import { finalize } from 'rxjs';



@Component({
	selector: 'app-simular-autos',
	standalone: true,
	imports: [
		CommonModule,
		UsoVehiculoComponent,
		CaCardComponent,
		ReactiveFormsModule,
		DatosPersonalesComponent,
		CaRadioButtonComponent,
		CaRadioGroupDirective,
		DatosDomicilioComponent,
		DatosConductorComponent,
		CoberturasComponent,
		CaIcon,
		CaButtonComponent,
		DatosAdicionalesComponent,
		TranslateModule,
		TarificacionComponent
	],
	templateUrl: './simular-autos.component.html',
	styleUrls: ['./simular-autos.component.scss']
})
export class SimularAutosComponent extends FlujoPolizaNavigationComponent implements OnInit {
	idPropuesta: number;
	version: Version;
	auto: Auto;
	catalogo: CatalogoProtocolo;
	simularForm: FormGroup;

	poliza: Poliza<Riesgo>;

	tomadorConfig: DatosPersonalesConfig;
	domicilioTomadorConfig: DatosDomicilioConfig;
	propietarioConfig: DatosPersonalesConfig;
	conductorConfig: DatosPersonalesConfig;

	mostrarOtrosIntervinientes = false;

	tomador: Persona;
	domicilioTomador: Domicilio;
	propietario: Persona;
	conductor: Persona;

	riesgoCarga: Riesgo = {};

	constructor(
		router: Router,
		catalogoSvgStore: CatalogoSvgStoreService,
		polizaStore: PolizaStoreService,
		private fb: FormBuilder,
		private location: Location,
		private autosBusquedaStore: AutosBusquedaStoreService,
		private polizaApiService: PolizaApiService,
		private autosService: AutosApiService,
		private authStore: AuthStoreService,
	) { 
		super(router, polizaStore, catalogoSvgStore);
		//Si venimos de volver vemos si se ha ido al siguiente paso con los otros intervinientes
		this.mostrarOtrosIntervinientes = this.getNavigationParam<boolean>('mostrarPropietario');
		this.idPropuesta = this.getNavigationParam('idPropuesta');
	}

	ngOnInit(): void {
		this.polizaStore.polizaSubject$.subscribe({
			next: (poliza)=> {
				if (poliza){
					this.poliza = poliza;
					const [primerRiesgo] = this.poliza.riesgos ?? [];
            		this.riesgoCarga = primerRiesgo;				
				}
			}
		});

		this.autosBusquedaStore.versionSeleccionadaSubject$.subscribe({
			next: (version) => {
				this.version = version;
			}
		});
		this.autosBusquedaStore.autoSeleccionadoSubject$.subscribe({
			next: (auto) => {
				this.auto = auto;
			}
		});
		this.catalogoSvgStore.catalogoProtocoloSubject$.subscribe({
			next: (catalogo) => {
				this.catalogo = catalogo;
			}
		});

		if (this.idPropuesta) {
			this.recuperarDatosPropuesta();
		} else {
			this.cargaDatosSimulacion();
		}
		
		const usuario = this.authStore.getUsuarioActivo();

		// TODO poner codProtocolo bien
		this.catalogoSvgStore.getCatalogoProtocolo(46, usuario);
		this.simularForm = this.fb.group({
			usoVehiculo: this.fb.group({}),
			datosPersonalesTomador: this.fb.group({}),
			datosDomicilioTomador: this.fb.group({}),
			datosObligatoriosConductor: this.fb.group({}),
			coberturas: this.fb.group({}),
			datosAdicionales: this.fb.group({})
		});

	}

	private recuperarDatosPropuesta() {
		this.polizaApiService.recuperarPropuesta(this.idPropuesta).subscribe({
			next: (propuesta) => {
				this.poliza = propuesta;
				this.polizaStore.setPoliza(propuesta);
				this.riesgoCarga = propuesta.riesgos.find(() => true);
				this.mostrarOtrosIntervinientes = this.riesgoCarga.propietario != null && this.riesgoCarga.propietario.documento !== this.poliza.tomador?.documento;
				if (this.mostrarOtrosIntervinientes) {
					this.anadirControlesOtrosIntervinientes();
				}
				this.cargaDatosSimulacion();
				this.tomador = propuesta.tomador;
				this.conductor = this.riesgoCarga?.conductor;
				this.propietario = this.riesgoCarga?.propietario;
				const versionPropuesta = this.riesgoCarga.preguntas?.find(p => p.idPregunta === 2125)?.respuesta;

				this.autosService.getVersionesPorMatricula(this.riesgoCarga.matricula).subscribe({
					next: (auto) => {
						this.auto = auto;
						this.version = auto.versiones?.find(v => v.version === String(versionPropuesta));
						this.autosBusquedaStore.setVersionSeleccionada(this.version);
						this.autosBusquedaStore.setAutoSeleccionado(this.auto);
					}
				});
			}
		});
	}

	private anadirControlesOtrosIntervinientes() {
		this.simularForm.addControl('datosPersonalesPropietario', this.fb.group({}));
		this.simularForm.addControl('datosPersonalesConductor', this.fb.group({}));
	}

	private cargaDatosSimulacion() {
		this.tomadorConfig = {
			persona: this.poliza?.tomador || {},
			rol: 'tomador',
			modoEdicion: ModoEdicion.SI,
			mostrarDocumento: true,
			mostrarNombre: false,
			mostrarFechaNacimiento: false,
			mostrarSexo: false
		};
		this.domicilioTomadorConfig = {
			domicilio: this.poliza?.tomador?.domicilio || {},
			rol: 'tomador',
			modoEdicion: ModoEdicion.SI,
			mostrarVia: false,
			mostrarLocalidad: true,
			mostrarProvincia: true
		};
		if (this.riesgoCarga && this.mostrarOtrosIntervinientes) {
			this.cargarConfiguracionOtrosIntervinientes();
		}
	}

	private cargarConfiguracionOtrosIntervinientes() {
		this.propietarioConfig = {
			...this.tomadorConfig,
			rol: 'propietario',
			persona: this.riesgoCarga.propietario || {}
		};
		this.conductorConfig = {
			...this.tomadorConfig,
			rol: 'conductor',
			persona: this.riesgoCarga.conductor || {}
		};
	}

	// Método que recibe el FormGroup del hijo y lo inserta en el principal
	onUsoVehiculoFormReady(usoVehiculoForm: FormGroup): void {
		this.simularForm.setControl('usoVehiculo', usoVehiculoForm);
	}

	cambioIntervinientes(evento: any) {
		if (evento.value === "2") {
			if (this.propietarioConfig === null || this.propietarioConfig === undefined){
				this.cargarConfiguracionOtrosIntervinientes()
			}
			this.anadirControlesOtrosIntervinientes();
			this.mostrarOtrosIntervinientes = true;
		} else {
			this.mostrarOtrosIntervinientes = false;
			this.simularForm.removeControl('datosPersonalesPropietario');
			this.simularForm.removeControl('datosPersonalesConductor');
		}
	}

	public onTomadorChange(persona: Persona): void {
		this.tomador = persona;
	}

	public onConductorChange(persona: Persona): void {
		this.conductor = persona;
	}

	public onPropietarioChange(persona: Persona): void {
		this.propietario = persona;
	}

	public onDomicilioTomadorChange(domicilio: Domicilio): void {
		this.domicilioTomador = domicilio;
	}

	volverSimulacion(): void {
		this.location.back();
	}

	tarificar(): void {
		this.poliza = this.crearPolizaTarificacion();
		this.polizaApiService.tarificarPoliza(this.poliza).pipe(finalize(() => {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		})).subscribe({
			next: (recibo) => {
				this.poliza.recibo = recibo;
			}
		});
	}

	crearPolizaTarificacion(): Poliza<Riesgo> {
		const preguntasSimu = this.catalogo.preguntas ? this.getPreguntasPoliza() : [];
		const coberturasSimu = this.catalogo.coberturas ? this.getCoberturasPoliza() : []
		const capitalesSimu = this.catalogo.capitales ? this.getCapitalesPoliza() : [];

		const riesgo: Riesgo = {
			numeroRiesgo: 1,
			capitales: capitalesSimu,
			coberturas: coberturasSimu,
			preguntas: preguntasSimu,
			matricula: this.simularForm.get('usoVehiculo')?.get('preg_matricula')?.value || null,
			bastidor: this.simularForm.get('usoVehiculo')?.get('preg_1173')?.value || null
		};

		this.tomador.domicilio = this.domicilioTomador;

		if (this.mostrarOtrosIntervinientes) {
			riesgo.propietario = this.propietario;
			riesgo.conductor = this.conductor;
		} else {
			riesgo.propietario = this.tomador;
			riesgo.conductor = this.tomador;
		}
		const valorIdioma = this.catalogo.idiomas?.find(idioma => idioma.valorDefecto === true)?.codigoIdioma || 'ES';

		const poliza: Poliza<Riesgo> = {
			tomador: this.tomador,
			fechaEfecto: this.simularForm.get('datosAdicionales').get('fEfecto')?.value ?? null,
			codigoFraccionamiento: this.simularForm.get('datosAdicionales').get('codFrac')?.value ?? null,
			codigoIdioma: valorIdioma,
			riesgos: [riesgo],
			codigoAgencia: this.catalogo.codAgencia,
			codigoAgente: this.catalogo.codAgente,
			nombreAgente: this.authStore.getUsuarioActivo(),
			codigoProtocolo: this.catalogo.idProtocolo,
			codigoCompannia: this.catalogo.codigoCompannia,
			codigoRamo: this.catalogo.codigoRamo,
			codigoModalidad: this.catalogo.codigoModalidad,
			codigoSubmodalidad: this.catalogo.codigoSubmodalidad,
			codigoProducto: this.catalogo.codigoProducto
		};
		return poliza;
	}

	private getCapitalesPoliza(): Capital[] {
		const capitalesForm = PolizaUtils.getFormValuesByPrefix(this.simularForm.value, 'cap_');
		return PolizaUtils.mapCapitales(capitalesForm, this.catalogo.capitales);
	}

	private getCoberturasPoliza(): Cobertura[] {
		const coberturasGroupValue = this.simularForm.get('coberturas')?.value || {};
		const coberturasForm = PolizaUtils.getFormValuesByPrefix(coberturasGroupValue, 'cob_');
		return PolizaUtils.mapCoberturas(coberturasForm, this.catalogo.coberturas);
	}

	private getPreguntasPoliza(): Pregunta[] {
		// Como las preguntas están distribuidas en varios grupos, une sus valores primero
		const usoVehiculoVals = this.simularForm.get('usoVehiculo')?.getRawValue() || {};
		const datosObligatoriosConductorVals = this.simularForm.get('datosObligatoriosConductor')?.getRawValue()  || {};
		const datosAdicionalesVals = this.simularForm.get('datosAdicionales')?.getRawValue()  || {};

		// Combina los objetos en uno solo
		const preguntasCombinadas = {
			...usoVehiculoVals,
			...datosObligatoriosConductorVals,
			...datosAdicionalesVals,
		};

		const preguntasForm = PolizaUtils.getFormValuesByPrefix(preguntasCombinadas, 'preg_');
		return PolizaUtils.mapPreguntas(preguntasForm, this.catalogo.preguntas);
	}

	guardarProyecto(): void {
		if (this.poliza) {
			this.polizaStore.setPoliza(this.poliza);
			this.navigate('/guardar-proyecto', true);
		}
	}

	contratarPoliza(recibo: Recibo): void {
		if (this.poliza) {
			this.poliza.recibo = recibo;
			this.polizaStore.setPoliza(this.poliza);
			this.navigate('/contratar-poliza', true,
				{
					mostrarPropietario: this.mostrarOtrosIntervinientes,
					mostrarConductor: this.mostrarOtrosIntervinientes
				});
		}
	}

}
